import { render } from "./ExpandableContent.vue?vue&type=template&id=5bdb4e67&scoped=true&lang=pug"
import script from "./ExpandableContent.vue?vue&type=script&lang=ts"
export * from "./ExpandableContent.vue?vue&type=script&lang=ts"

import "./ExpandableContent.vue?vue&type=style&index=0&id=5bdb4e67&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5bdb4e67"

export default script